import { createContext } from 'react';
import type { FrontendConfiguration } from '../../api/generated/client';
import type { LocalStore } from './app-environment-local-store';

interface IAppEnvironmentContext extends FrontendConfiguration {
    localStore: LocalStore;
}

export const appEnvironmentContext = createContext<IAppEnvironmentContext | null>(null);
